import { LOGIN, USER_LOGOUT, USER_ROLE, SET_USER_ID } from '../actions/types';

const initialState = {
  user: {},
  role: null,
  userNo: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return { ...state, user: action.payload };

    case USER_ROLE:
      return { ...state, role: action.payload };

    case SET_USER_ID:
      return { ...state, userNo: action.payload }; // ← STORE userNo here

    case USER_LOGOUT:
      return { user: null, role: null, userNo: null }; // ← reset everything

    default:
      return state;
  }
};

export default userReducer;
